import Swal from "sweetalert2";
import { Path } from "../../Api/Path";
// Add custom CSS to increase z-index
const style = document.createElement("style");
style.innerHTML = `
  .swal2-high-z-index {
    z-index: 30000 !important;
  }
`;
document.head.appendChild(style);

export const SwalSuccess = (Prtitle) => {
  const Toast = Swal.mixin({
    toast: true,
    position: "top-end",
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
    customClass: {
      container: "swal2-high-z-index",
    },
    didOpen: (toast) => {
      toast.addEventListener("mouseenter", Swal.stopTimer);
      toast.addEventListener("mouseleave", Swal.resumeTimer);
    },
  });

  Toast.fire({
    icon: "success",
    title: Prtitle,
  });
};

export const SwalFail = (Prtitle) => {
  Swal.fire({
    title: Prtitle,
    confirmButtonText: "Đóng",
    showClass: {
      popup: "animate__animated animate__fadeInDown",
    },
    hideClass: {
      popup: "animate__animated animate__fadeOutUp",
    },
  });
};

export const SwalQuesionYN = (title) => {
  let isAccess = false;
  Swal.fire({
    title: title,
    showDenyButton: true,
    confirmButtonText: "Đồng ý",
    denyButtonText: `hủy`,
  }).then((result) => {
    if (result.isConfirmed) {
      isAccess = true;
    }
  });
  return isAccess;
};

export const SwalError = (Prtitle) => {
  Swal.fire({
    title: Prtitle,
    confirmButtonText: "Liên hệ",
    showClass: {
      popup: "animate__animated animate__fadeInDown",
    },
    hideClass: {
      popup: "animate__animated animate__fadeOutUp",
    },
  }).then((result) => {
    if (result.isConfirmed) {
      // Mở một tab mới
      const url = Path.SUPPORT;
      const link = document.createElement("a");
      link.href = url;
      link.target = "_blank";
      link.click();
    }
  });
};
